import { render, staticRenderFns } from "./ColorSelect.vue?vue&type=template&id=5bfe08e3&"
import script from "./ColorSelect.vue?vue&type=script&lang=js&"
export * from "./ColorSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bfe08e3')) {
      api.createRecord('5bfe08e3', component.options)
    } else {
      api.reload('5bfe08e3', component.options)
    }
    module.hot.accept("./ColorSelect.vue?vue&type=template&id=5bfe08e3&", function () {
      api.rerender('5bfe08e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/utils/colorSelect/ColorSelect.vue"
export default component.exports